<template>
  <div>
    <b-alert :show="working" variant="info" class="d-flex align-items-center px-5">
      <strong>Working...</strong>
      <b-spinner class="ml-auto"></b-spinner>
    </b-alert>
    <div v-if="registration">
      <h4>Event Registration</h4>
      <h5>Participant: <router-link :to="{ name: 'participantDetails', params: { pid: registration.participant.id } }">{{ registration.participant.fullName }}</router-link><small> ({{ $moment(registration.datetime).diff(registration.participant.dob, 'years') }} y/o {{ registration.participant.gender }})</small></h5>
      <h5>Event: <router-link :to="{ name: 'eventDetails', params: { eid: registration.event.id } }">{{ registration.event.title }}</router-link></h5>
      <p>
        Date of Registration: {{ $moment(registration.datetime).format('MMMM Do YYYY, h:mm a') }}<br />
        Registration Cost: <template v-if="invoiceItem"><router-link :to="{ name: 'invoiceDetails', params: { iid: registration.invoice.id } }">${{ invoiceItem.price }}</router-link></template><span v-else>No invoice</span>
      </p>
      <b-card-group deck class="mb-3">
      <b-card v-if="registration.questionResponses" bg-variant="info" title="Question Responses"><div v-html="questionResponsesText"></div></b-card>
      <b-card v-if="addOnItems.length" bg-variant="warning" title="Add-On Items">
        <div v-for="item in addOnItems" :key="item.id">
          <b>{{ item.item }}</b>
        </div>
      </b-card>
      </b-card-group>
      <p v-if="registration.request">
        Registrant Notes: {{ registration.request }}
      </p>
      <p v-if="registration.notes">
        Admin Notes: {{ registration.notes }}
      </p>
      <p>
        Waiver:<br />
        <span v-html="waiverContent"></span>
      </p>
      <b-btn-group class="float-right d-print-none">
        <BtnPrint btnClass="" />
        <b-btn v-if="isDirector" title="Edit the registration" variant="warning" :to="{ name: 'eventRegistrationForm', params: { rid: $route.params.rid }}">Edit</b-btn>
      </b-btn-group>
    </div>
    <p v-else-if="!working">
      No registration data loaded
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      working: false,
      registration: null,
      invoiceItem: null,
      invoiceItems: [],
      waiverContent: null
    }
  },
  computed: {
    ...mapGetters([
      'eventQuestions'
    ]),
    addOnItems () {
      return this.invoiceItems.filter(item => item.pid.startsWith(`ADDON-${this.registration.id}-`))
    },
    questionResponsesText () {
      let text = "",
      qRList = this.registration.questionResponses
      for (let qid in qRList) {
        let thisQuestionId = qid,
        thisQuestionRespId = qRList[qid]
        for (let q in this.eventQuestions) {
          if (this.eventQuestions[q].options.length) {
            for (let qro in this.eventQuestions[q].options) {
              if (thisQuestionId == this.eventQuestions[q].id && thisQuestionRespId == this.eventQuestions[q].options[qro].id) {
                text += '<div><b>' + this.eventQuestions[q].label + '</b>: ' + this.eventQuestions[q].options[qro].label + '</div>'
              }
            }
          } else {
            if (thisQuestionId == this.eventQuestions[q].id && thisQuestionRespId) {
              text += '<div><b>' + this.eventQuestions[q].label + '</b>: ' + thisQuestionRespId + '</div>'
            }
          }
        }
      }
      return text
    }
  },
  methods: {
    ...mapActions([
      'getEventRegistration',
      'getInvoiceItems',
      'getEventQuestions',
      'getContent'
    ]),
    async getWaiver () {
      // look for event type-specific waiver
      let waiver = await this.getContent({
        type: 'agreement',
        slug: 'waiver-' + this.registration.event.type.split('/')[3]
      })
      if (waiver.length) {
        this.waiverContent = waiver[0].content
      } else {
        // fallback to general waiver
        waiver = await this.getContent({
          type: 'agreement',
          slug: 'waiver-0'
        })
        if (waiver.length) {
          this.waiverContent = waiver[0].content
        } else {
          this.waiverContent = '<p>No waiver found</p>'
        }
      }
    },
    async doGetEventRegistration () {
       // this.working = true
      if (this.$route.params.rid) {
        let registration = await this.getEventRegistration(this.$route.params.rid)
        await this.getInvoiceItems({
          // get the invoice item for this registration
          registration: this.$route.params.rid
        }).then(resp => {
          this.invoiceItem = resp[0]
        })
        this.registration = registration
        // TODO: remove once waiver is stored in the registration
        this.registration.waiver = this.registration.waiver || this.getWaiver()
      }
      // this.working = false
    },
    async doGetInvoiceItems () {
      this.invoiceItems = await this.getInvoiceItems({
        invoice: this.invoiceItem.invoice
      })
    }
  },
  async mounted () {
    await this.doGetEventRegistration()
    if (this.invoiceItem?.id) {
      await this.doGetInvoiceItems()
    }
    await this.getEventQuestions()
  }
}
</script>
